import { Text, Heading, Button, Img } from "./..";
import React from "react";

export default function SolutionsFeature({
  featureheading = "Machine Boost",
  description = "&lt;&gt;Real-time OEE&lt;br /&gt;Machine Diagnostics & Prognostics&lt;br /&gt;Predictive maintenance&lt;br /&gt;Remote monitoring and control&lt;br /&gt;Routing flexibility&lt;br /&gt;Augmented reality for MRO&lt;/&gt;",
  ...props
}) {
  return (
    <div
      {...props}
      className={`${props.className} flex flex-col h-full items-start gap-4 p-[34px] sm:p-5 bg-gradient3 rounded-lg max-w-full`}
      style={{ boxSizing: "border-box" }} // Ensure padding doesn't cause overflow
    >
      <Button
        size="5xl"
        variant="gradient"
        color="color_style_linear_gradient_gray_900_05"
        className="w-[58px] rounded px-4"
      >
        <Img src="images/img_forward.svg" />
      </Button>
      <Heading size="heading7xl" as="h4" className="text-[24px] font-bold text-color_style-01_neutrals-grey700">
        {featureheading}
      </Heading>
      <Text
        size="text3xl"
        as="p"
        className="w-full text-[16px] font-normal leading-[25px] text-color_style-01_neutrals-grey600"
      >
        {description}
      </Text>
    </div>
  );
}
